module.exports = __webpack_public_path__ + "img/android1icon2.54041ae5.png";